'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_Vars$() {
}
export { $c_Lpresto_Vars$ as $c_Lpresto_Vars$ };
$p = $c_Lpresto_Vars$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_Vars$;
/** @constructor */
function $h_Lpresto_Vars$() {
}
export { $h_Lpresto_Vars$ as $h_Lpresto_Vars$ };
$h_Lpresto_Vars$.prototype = $p;
$p.cwo = (function(v) {
  $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lcom_raquo_airstream_state_Var__update__F1__V(v, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((value) => (!(!(!value))))));
});
var $d_Lpresto_Vars$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_Vars$, "presto.Vars$", ({
  UY: 1
}));
export { $d_Lpresto_Vars$ as $d_Lpresto_Vars$ };
var $n_Lpresto_Vars$;
function $m_Lpresto_Vars$() {
  if ((!$n_Lpresto_Vars$)) {
    $n_Lpresto_Vars$ = new $c_Lpresto_Vars$();
  }
  return $n_Lpresto_Vars$;
}
export { $m_Lpresto_Vars$ as $m_Lpresto_Vars$ };
//# sourceMappingURL=presto.-Vars$.js.map
